// extracted by mini-css-extract-plugin
export default {"star":"l7EGbR","small":"h4WnTG","interactive":"W_ThTd","link":"CUP205"};